define((require, exports, module) => {
    'use strict';

    const RPCModel = require('RPCModel');

    const CsrfTokenModel = RPCModel.extend({
        className: 'MCS.CsrfToken',

        addUrl: 'tokens/csrf',

        defaults: {
            email: '',
            token: '',
        },

        prepareSendData(method, attrs) {
            if (!attrs.token) {
                delete attrs.token;
            }

            return attrs;
        },
    });

    module.exports = CsrfTokenModel;
});
